export const getProcessingFinancingFilter = state => state.financing.filter
